var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 39.375V35.625C38 33.6359 37.2098 31.7282 35.8033 30.3217C34.3968 28.9152 32.4891 28.125 30.5 28.125H15.5C13.5109 28.125 11.6032 28.9152 10.1967 30.3217C8.79018 31.7282 8 33.6359 8 35.625V39.375",
    stroke: "black",
    strokeWidth: 1.95652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20.625C27.1421 20.625 30.5 17.2671 30.5 13.125C30.5 8.98286 27.1421 5.625 23 5.625C18.8579 5.625 15.5 8.98286 15.5 13.125C15.5 17.2671 18.8579 20.625 23 20.625Z",
    stroke: "black",
    strokeWidth: 1.95652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1758,
    cy: 40.0469,
    r: 11.5,
    fill: "#EF2C5A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0288 36.5323C43.3217 36.2394 43.3217 35.7645 43.0288 35.4716C42.7359 35.1787 42.261 35.1787 41.9681 35.4716L38.3136 39.1261L34.6592 35.4717C34.3663 35.1788 33.8915 35.1788 33.5986 35.4717C33.3057 35.7646 33.3057 36.2395 33.5986 36.5324L37.253 40.1868L33.5986 43.8412C33.3057 44.1341 33.3057 44.6089 33.5986 44.9018C33.8915 45.1947 34.3663 45.1947 34.6592 44.9018L38.3136 41.2474L41.9681 44.9019C42.261 45.1948 42.7359 45.1948 43.0288 44.9019C43.3217 44.609 43.3217 44.1341 43.0288 43.8413L39.3743 40.1868L43.0288 36.5323Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPerson);
export default __webpack_public_path__ + "static/media/empty-person.1908bffe880c11fdd2291e3e8045c781.svg";
export { ForwardRef as ReactComponent };